import { DetailsTabs, PanelTypes } from '../constants';
import { FrameStateTypes, frameStateBuilder } from './frameState';
export { DetailsTabs, PanelTypes };
export const DetailPanelActionButtons = {
  SHARE: 'SHARE',
  EDIT: 'EDIT',
  INSERT: 'INSERT',
  ARCHIVE: 'ARCHIVE',
  DOWNLOAD: 'DOWNLOAD',
  REMIX: 'REMIX',
  EDIT_IN_DESCRIPT: 'EDIT_IN_DESCRIPT',
  COPY_URL: 'COPY_URL',
  OPEN_IN_NEW_TAB: 'OPEN_IN_NEW_TAB',
  MOVE_TO_TRASH: 'MOVE_TO_TRASH',
  DIVIDER: 'DIVIDER',
  DONE: 'DONE'
};
export const COMMON_ACTIONS = [{
  type: 'DOWNLOAD'
}, {
  type: 'REMIX'
}, {
  type: 'EDIT_IN_DESCRIPT'
}, {
  type: 'DIVIDER'
}, {
  type: 'COPY_URL'
}, {
  type: 'OPEN_IN_NEW_TAB'
}, {
  type: 'DIVIDER'
}, {
  type: 'ARCHIVE'
}];
export const getDetailsConfig = ({
  showDelete = false,
  showShare = true
} = {}) => {
  return {
    panelActions: {
      primary: {
        type: showShare ? 'SHARE' : 'DONE'
      },
      secondary: {
        type: 'EDIT'
      },
      tertiary: [...COMMON_ACTIONS, ...(showDelete ? [{
        type: 'MOVE_TO_TRASH'
      }] : [])]
    }
  };
};
const getCurrentApp = () => {
  // @ts-ignore hubspot.bender lacks types
  if (!(window.hubspot && window.hubspot.bender)) {
    return undefined;
  }
  return window.hubspot.bender.currentProject;
};

// NOTE: If you are adding a new value to state and referencing it in video-management-ui's
// EmbedVideoPanelState, CHECK FOR EXPLICIT VALUES (e.g. not truthy/falsy). The value may
// be undefined in consuming apps that have not deployed with the latest version of this libary.
export const videoPanelStateBuilder = frameStateBuilder().setInitialState({
  activePanel: null,
  enableAdvancedFeaturesOnInsert: true,
  enablePrivateInsert: false,
  insertionCriteria: [],
  hostApp: getCurrentApp(),
  isManagementPanelLoading: false,
  state: {
    [PanelTypes.DETAILS]: {
      selectedTab: DetailsTabs.OPTIMIZATION
    },
    [PanelTypes.PICKER]: {
      allowUpload: true,
      allowBulkSelect: false,
      bulkSelectionLimit: 10
    },
    [PanelTypes.CLIP_EDITOR]: {
      projectId: null,
      referrerPanel: null,
      isLoading: false,
      sourceFileId: null
    }
  },
  config: {
    [PanelTypes.DETAILS]: getDetailsConfig()
  }
}).setStateName('@@video-components-external/VideoPanelState');
export const VideoPanelState = videoPanelStateBuilder.setStateType(FrameStateTypes.LEADER).build();
export const isStandaloneDetailsPanel = panelState => {
  const primaryPanelAction = panelState.config[PanelTypes.DETAILS].panelActions.primary.type;
  return panelState.activePanel === PanelTypes.DETAILS && (primaryPanelAction === 'SHARE' || primaryPanelAction === 'DONE');
};